import * as ko from 'knockout';
import entityBase from 'entityBase';
import { user_role } from 'entitiesE';

export class person_role extends entityBase {
    person_id: KnockoutObservable<string>;
    user_def2: KnockoutObservable<string>;
    user_def4: KnockoutObservable<string>;
    user_role: KnockoutObservable<user_role>;

    constructor(item: any){
        super();
        this.person_id = ko.observable(item.person_id).extend({ maxLength: 32 });
        this.user_def2 = ko.observable(item.user_def2).extend({ maxLength: 256 });
        this.user_def4 = ko.observable(item.user_def4).extend({ maxLength: 256 });
        this.user_role = ko.observable();
        if(item.user_role) {
            this.user_role= <KnockoutObservable<user_role>>this.loadRelation(item,user_role, "user_role", "single");
        }
    }
}


